/** Platform operators — not tenant `org:admin`. */
export const SUPER_ADMIN_EMAILS = ["zach@justsomepeople.com"] as const;

export type AppMode = "matrix" | "admin";

export type AdminNav =
	| "home"
	| "roster"
	| "kit"
	| "tenants"
	| "audit";

export const ADMIN_NAV: ReadonlyArray<{
	id: AdminNav;
	label: string;
	lede: string;
}> = [
	{
		id: "home",
		label: "Home",
		lede: "Firm pulse — kit health, open desks, and what needs a human.",
	},
	{
		id: "roster",
		label: "Roster",
		lede: "Mairko specialists as employees — titles, status, who’s staffed where.",
	},
	{
		id: "kit",
		label: "Agent kit",
		lede: "Mailboxes, LinkedIn, numbers — the outside-world tools each agent owns.",
	},
	{
		id: "tenants",
		label: "Tenants",
		lede: "Client desks. Open one only with a clear banner and an audit trail.",
	},
	{
		id: "audit",
		label: "Audit",
		lede: "Operator actions and break-glass access across the firm.",
	},
];

const MODE_KEY = "mairko-matrix-app-mode";

export function normalizeEmail(email: string): string {
	return email.trim().toLowerCase();
}

/** True when this Clerk user is a Mairko platform super-admin. */
export function isMairkoAdmin(email: string | null | undefined): boolean {
	if (!email) return false;
	const normalized = normalizeEmail(email);
	return SUPER_ADMIN_EMAILS.some((entry) => entry === normalized);
}

export function readAppMode(): AppMode {
	if (typeof window !== "undefined") {
		const hash = window.location.hash.replace(/^#/, "").toLowerCase();
		if (hash === "admin") return "admin";
	}
	try {
		const raw = localStorage.getItem(MODE_KEY);
		if (raw === "admin") return "admin";
	} catch {
		/* ignore */
	}
	return "matrix";
}

export function writeAppMode(mode: AppMode): void {
	try {
		localStorage.setItem(MODE_KEY, mode);
	} catch {
		/* ignore */
	}
	if (typeof window === "undefined") return;
	const url = new URL(window.location.href);
	if (mode === "admin") {
		url.hash = "admin";
	} else if (url.hash.replace(/^#/, "").toLowerCase() === "admin") {
		url.hash = "";
	}
	window.history.replaceState(
		null,
		"",
		`${url.pathname}${url.search}${url.hash}`,
	);
}
